import React from "react";
import "./TeamcenterIntegrationforCAE.css";
import TeamcenterIntegrationforCAEOverview from "./TeamcenterIntegrationforCAEOverview";
import Teacher from "../../../assets/images/plmimplementationimage/Teacher-amico.png";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import BannerImage from "../../../assets/other_image/intigretion.jpg";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const TeamcenterIntegrationforCAE = () => {
  return (
    <section className="TeamcenterIntegrationforCAE-management">
                                                    <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Integration for CAE" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>

     
       
        <TeamcenterIntegrationforCAEOverview />
        <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="TeamcenterIntegrationforCAE-page-heading">
            Unlock the Power :
          </h4>
          <h5 className="TeamcenterIntegrationforCAE-subheading">
            Discover the Transformative Benefits of Teamcenter Integration for CAE with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              CAE data consistency and traceability throughout the product
              lifecycle{" "}
            </li>
            <li>
              Less time spent by your technical staff in finding the correct
              revisions of CAE data{" "}
            </li>
            <li>Consistent work process followed across all data formats</li>
            <li>
              Faster product change and approval processes resulting in
              decreased time-to-market{" "}
            </li>
            <li>
              CAE files integrated with all of your technical data to provide a
              single source of product information that supports your complete
              design through- manufacturing process{" "}
            </li>
          </ul>
        </div>
        </section>

        <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="TeamcenterIntegrationforCAE-page-heading">Teamcenter Solutions</h4>

          <ul className="custom-bullets">
          <li>
              CAE tool (Pre-processor, Post Processor & Solver) like Ansys,
              Hyper mesh .
            </li>
            <li>NX Nastran integration & configuration </li>
            <li>Defining required Schema & its mapping </li>
            <li>CAE object properties with Teamcenter schema </li>
            <li>Filter rules & reuse rules </li>
            <li>Data mapping include rules etc. </li>
          </ul>
 
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li><NavLink to={"/teamcenter/cloud-implementation"} >Teamcenter Implementation on Cloud</NavLink></li>
              <li><NavLink to={"/teamcenter/implementation"} >Teamcenter Implementation
              </NavLink></li>
              <li><NavLink to={"/teamcenter/cam-integration"} >Teamcenter Integration for CAM
              </NavLink></li>
              <li><NavLink to={"/teamcenter/performance-tuning-health-checkup"} >Teamcenter Performance Tuning & Health Check-up
              </NavLink></li>
              <li><NavLink to={"/teamcenter/program-project-management"} >Teamcenter Project Management
              </NavLink></li>
             
              <li><NavLink to={"/teamcenter/rac-to-aw-client-transition"} >Teamcenter RAC to Active Workspace Client Transition
              </NavLink></li>
              <li><NavLink to={"/teamcenter/upgrade-migration"} >Teamcenter Upgrade & Migration
              </NavLink></li>
              <li><NavLink to={"/teamcenter/reporting-analytics"} >Reporting and Analytics

              </NavLink></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        <section style={{ background: "#f5f7fa" }}>
        <div className="best-practices container">
          <h4 className="TeamcenterIntegrationforCAE-page-heading">
            Best Practices
          </h4>
          <p className="plmimplementationparagraph">
            {" "}
            We help you to enable best practices while performing various
            activities in manage mode environments on CAE data, launching CAE
            tools, Pre-Processing, Solving, Post Processing and Viewing the
            result in context of Teamcenter, data exchange with various
            department. Best in class workflow implementation which consist of
            various activities to achieve productivity. Using CAE Manager,
            Structure Designer, Using Batch Meshing Tool, Automatic CAE
            structure creation from product structure and CAE structure
            configuration,{" "}
          </p>
        </div>
        </section>

        <section>
        <div className="why-nextech container">
          <h4 className="TeamcenterIntegrationforCAE-page-heading">
            Why NexTech?
          </h4>
          <h5 className="TeamcenterIntegrationforCAE-subheading">
            For Teamcenter Integration for CAE 
          </h5>
          <ul className="custom-bullets">
            <li>
            Expert CAE tool integration with Ansys and Hyper Mesh for seamless data management. 
            </li>
            <li>
            NX Nastran integration services for efficient simulation data utilization. 
            </li>
            <li>
            Schema definition and mapping ensure consistency in CAE object properties. 
            </li>
            <li>
            Implementation of best practices enhances productivity in CAE data management. 
            </li>
            <li>
            Workflow optimization streamlines CAE data exchange and accelerates decision-making.
            </li>
          </ul>
        </div>
        </section>
        <Letsgetintouch/>
    </section>
  );
};

export default TeamcenterIntegrationforCAE;
